import { render, staticRenderFns } from "./cropperDialogs.vue?vue&type=template&id=72bd4959&"
import script from "./cropperDialogs.vue?vue&type=script&lang=js&"
export * from "./cropperDialogs.vue?vue&type=script&lang=js&"
import style0 from "./cropperDialogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VDivider,VSpacer})
